export const ENetworkEventClientOnly = {
  ERROR: 'error',
  CONNECT: 'connect',
  RECONNECT: 'reconnect',
  CONNECT_ERROR: 'connect_error',
};
